import React, { ReactNode, useEffect, useState } from 'react'
import styles from '../styles/desensitzePhone.module.scss'
import Dialog from '@/wmCompoments/dialog'
import VerificationCode from '@/antComponent/securityCheck/verificationCode'
import SecurityCheck from '@/antComponent/securityCheck'
import { useDecryptData, useSendCode, useUserInfo } from '@/api/request'
import Toast from '@/wmCompoments/toast'
import { useTranslation } from 'react-i18next'

interface Props {
    visible: boolean
    onClose?: () => void
    className?: string
    onSuccess?: (v:string) => void
    encryptedString: string
    fingerprint: string
}

const DesensitzePhone = (props: Props) => {
    const { visible, onClose, onSuccess , encryptedString = '' , fingerprint} = props
    const { t } = useTranslation('accountManagement')
    const [value, setValue] = useState('')

    const { trigger: triggerCode } = useSendCode()

    const { data } = useUserInfo()

    const [visibleCheck, setVisibleCheck ] = useState(false)

    const { trigger } = useDecryptData()

    const handleSubmit = async () => {
        try {
            const data = await trigger({
                code: value,
                encryptedString,
                fingerprint
            })
            window.isVerifyEencryption = true
            onSuccess?.(data?.data)
            onClose?.()
        } catch (error: any) {
            Toast.show(error?.message ?? JSON.stringify(error))
        }
    }

    const handleSendCode = async (v) => {
        try {
            await triggerCode({
                cate: 0,
                type: 8,
                sendCodeNum: v
            })
           
        } catch (error: any) {
            Toast.show(error?.message ?? JSON.stringify(error))
        }
    }

    useEffect(() => {
        setValue('')
    }, [visible])

    return (
        <>
            <Dialog
                visible={visible}
                onClose={() => {
                    props?.onClose?.()
                }}
                actions={[

                    {
                        key: 'cancel',
                        text: t('cancel'),
                        onClick: () => {
                            onClose?.()
                        }
                    },
                    {
                        key: 'confirm',
                        text: t('verify'),
                        onClick: async () => {
                           return handleSubmit()
                            //onClose?.()
                        }
                    }
                ]}
                content={
                    <div className={styles.dialog_content}>
                        <span>{t('dataDecryption')}</span>
                        <div className={styles.phone}>
                            <span>{t('enterPhoneNumber')}</span>
                            <span>86155****8888</span>
                            <span>{t('receiveVerificationCode')}</span>
                        </div>

                        <VerificationCode value={value} onChange={(v) => {
                            setValue(v)
                        }} length={6} />

                        <div className={styles.sendCode} onClick={()=>{
                            setVisibleCheck(true)
                        }}>
                            {t('sendVerificationCode')}
                        </div>
                    </div>
                }
            />

            <SecurityCheck visible={visibleCheck} onClose={()=>{
                setVisibleCheck(false)
            }} onSubmit={handleSendCode} phone={data?.phone}/>
        </>
    )
}

export default DesensitzePhone


